<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nqQwJ6/tc-custom/9781461640950.jpg?1705766068856" alt="This image is the cover for the book Plutarco Elías Calles and the Mexican Revolution, Latin American Silhouettes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plutarco Elías Calles and the Mexican Revolution, Latin American Silhouettes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This biography of the Mexican revolutionary examines his rise from soldier to president to his continued influence as <i>Jefe Maximo</i>.</b></p><p> Hailing from the border state of Sonora, Plutarco Elías Calles found his calling in the early years of the revolution, quickly rising to national prominence. As president from 1924 to 1928, Calles undertook an ambitious reform program, modernized the financial system, and defended national sovereignty against an interventionist U.S. government. Yet these reforms failed to eradicate underdevelopment, corruption, and social injustice. Moreover, his unyielding campaigns against political enemies and the Catholic Church earned him a reputation as a repressive strongman.<br/><br/> After his term as president, Calles continued to exert broad influence as his country's foremost political figure while three weaker presidents succeeded each other in an atmosphere of constant political crisis. He played a significant role in founding a ruling party that reined in power-hungry military leaders and helped workers attain better living conditions. This dynastic party and its successors, including the present-day <i>Partido Revolucionario Institucional</i> (Party of the Institutional Revolution), remained in power until 2000. Through this comprehensive assessment of a quintessential Mexican politician, Buchenau opens an illuminating window into both the Mexican Revolution and contemporary Mexico. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jürgen Buchenau
      </h2>
      
      <p class="authorDescription body article">Jürgen Buchenau is professor of history and director of Latin American studies at the University of North Carolina at Charlotte.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ROWMAN & LITTLEFIELD PUBLISHERS, INC.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f8be0d4